import { render, staticRenderFns } from "./Languages.vue?vue&type=template&id=516b7c68"
import script from "./Languages.vue?vue&type=script&lang=js"
export * from "./Languages.vue?vue&type=script&lang=js"
import style0 from "./Languages.vue?vue&type=style&index=0&id=516b7c68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports